"use client";

import { useRef } from "react";
import { Award, CircleCheck as CheckCircle2, GraduationCap } from 'lucide-react';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function MakingTheWorldABetterPlace() {
  const container = useRef<HTMLElement>(null);
  const credentials = [{
    icon: Award,
    label: "Registered Nonprofit"
  }, {
    icon: CheckCircle2,
    label: "Community Impact"
  }, {
    icon: GraduationCap,
    label: "Global Outreach"
  }];
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add({
      reduced: "(prefers-reduced-motion: reduce)",
      full: "(prefers-reduced-motion: no-preference)"
    }, context => {
      const {
        reduced
      } = context.conditions as {
        reduced: boolean;
      };
      if (reduced) {
        gsap.set([".portrait-wrap", ".floating-card", ".headline-line", ".body-para", ".pull-line", ".signature", ".eyebrow-pill", ".underline-swipe"], {
          opacity: 1,
          y: 0,
          scale: 1,
          clearProps: "transform"
        });
        gsap.set(".underline-swipe", {
          scaleX: 1
        });
        return;
      }
      gsap.from(".portrait-wrap", {
        opacity: 0,
        scale: 0.98,
        duration: 0.8,
        ease: "power2.out",
        scrollTrigger: {
          trigger: container.current,
          start: "top 75%"
        }
      });
      gsap.from(".floating-card", {
        opacity: 0,
        y: 16,
        duration: 0.6,
        delay: 0.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: container.current,
          start: "top 75%"
        }
      });
      gsap.from(".eyebrow-pill", {
        opacity: 0,
        y: 12,
        duration: 0.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".text-column",
          start: "top 80%"
        }
      });
      gsap.from(".headline-line", {
        opacity: 0,
        y: 32,
        duration: 0.7,
        stagger: 0.08,
        ease: "cubic-bezier(0.22, 0.61, 0.36, 1)",
        scrollTrigger: {
          trigger: ".text-column",
          start: "top 80%"
        }
      });
      gsap.from(".underline-swipe", {
        scaleX: 0,
        transformOrigin: "left center",
        duration: 0.6,
        delay: 0.4,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".text-column",
          start: "top 80%"
        }
      });
      gsap.from(".body-para", {
        opacity: 0,
        y: 20,
        duration: 0.6,
        stagger: 0.1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".text-column",
          start: "top 70%"
        }
      });
      gsap.from(".pull-line", {
        opacity: 0,
        y: 24,
        duration: 0.7,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".pull-line",
          start: "top 85%"
        }
      });
      gsap.from(".signature", {
        opacity: 0,
        y: 12,
        duration: 0.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".signature",
          start: "top 90%"
        }
      });
    });
  }, {
    scope: container
  });
  return;
}